import {DeepPartial} from 'react-hook-form';

import {RefreshDatagridOptions} from '../hooks/useRefreshServerSideStore';
import {RefreshCellsParams} from './AgGridTypes';

export type ActionCallbackParams<T extends readonly string[]> = {
  actionKey: string;
  rowId: string | string[];
  getColumnData: <C = unknown, S = unknown>(
    column: T[number],
    options?: {isOptional?: boolean}
  ) => {value: DeepPartial<C>; style: DeepPartial<S>} | null;
  /**
   * @deprecated use getColumnData instead
   */
  rowData: Record<string, unknown> | Array<Record<string, unknown>>;
  refreshData: (options?: RefreshDatagridOptions) => void;
  refreshCells: (params?: RefreshCellsParams) => void;
  redrawRows: () => void;
  deselectAll: () => void;
  sourceSearchParams: string;
  queryId: string;
};

export type ActionCallbackReturnType = string | void | Promise<string | void>;
export type ActionCallback<T extends readonly string[] = never> = (
  params: ActionCallbackParams<T>
) => ActionCallbackReturnType;
